import React from "react";
import caretIcon from "../../assets/icon/CaretCircleRight.svg";

export default function SolutionCard({
  title,
  items = [],
  children,
  className = "",
  borderColors = ["#036AE5", "#FFFFFF"],
  borderWidth = 1,
  radius = 16,
}) {
  const gradient = `linear-gradient(to bottom, ${borderColors.join(",")})`;

  return (
    <div className={`relative w-full min-h-[220px] flex flex-col ${className}`}>
      <div
        aria-hidden="true"
        className="absolute inset-0 rounded-[inherit] pointer-events-none"
        style={{
          padding: borderWidth,
          borderRadius: radius,
          background: gradient,
          WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
        }}
      />

      <div
        className="
          rounded-[inherit] bg-white/5 p-6 overflow-hidden
          hover:bg-white/15 min-h-[220px]
          transition-colors duration-1000 ease-in-out
        "
        style={{ borderRadius: radius }}
      >
        <div
          className="absolute -top-10 -left-10 w-40 h-40 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(255,255,255,0.6), transparent 70%)",
            filter: "blur(60px)",
          }}
        />

        {/* Nội dung card */}
        <h3 className="text-[24px] font-semibold tabletpro:text-[20px] tabletair:text-[24px] 
        tabletmini:text-[24px] mobile:text-[16px] text-[#E6F0FC] font-bold mb-4">{title}</h3>
        {children ?? (
          <ul className="space-y-4 text-[16px] font-normal tabletpro:text-[16px] tabletair:text-[16px]
           tabletmini:text-[16px] mobile:text-[14px] text-neutral-5">
            {items.map((it, idx) => (
              <li key={idx} className="flex items-start gap-2">
                <img
                  src={caretIcon}
                  alt="bullet point"
                  className="w-6 h-6 shrink-0"
                  draggable="false"
                />
                <span>{it}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
